import {Swiper, Navigation, Autoplay, Pagination, Lazy} from 'swiper/dist/js/swiper.esm.js';
import {domReady, iterateNodes} from './dom';

export default class SliderInitializer {
    constructor(defaultSettings) {
        this.defaultSettings = defaultSettings;
        this.fixedSettings = {
            slideActiveClass: '-active',
            slideDuplicateActiveClass: '-active',
            pagination: {
                el: '.indicator-nav',
                clickable: true,
                bulletClass: 'bullet',
                bulletActiveClass: '-active',
                bulletElement: 'div'
            }
        };
        iterateNodes('[data-slider]', this.initSlider, this);
    }

    initSlider(slider, initializerInstance) {
        let customSettings = JSON.parse(slider.getAttribute('data-slider-settings')) || initializerInstance.defaultSettings;
        let numberOfSlides = slider.getAttribute('data-slides');
        let loopedSlides = Math.floor(numberOfSlides / 2) + 1;
        let sliderSettings = Object.assign({}, initializerInstance.fixedSettings, customSettings, {loopedSlides: loopedSlides});
        Swiper.use([Navigation, Pagination, Autoplay, Lazy]);
        let swiper = new Swiper(slider, sliderSettings);

        swiper.on('init', () => {
            lazySizes.init();
        });

        swiper.init();
    }
}

let initialized = false;

function init() {
    let defaultSliderSettings = {
        speed: 500,
        init: false,
        loop: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        threshold: 10,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: '.slide-next',
            prevEl: '.slide-prev',
        },
    };

    if (initialized === false) {
        new SliderInitializer(defaultSliderSettings);
    }

    initialized = true;
}

window.addEventListener('css-loaded', init);

// if CSS loads before listener is attached
window.addEventListener('load', init);

